import { render, staticRenderFns } from "./MediaSelect.vue?vue&type=template&id=45f79cb2&scoped=true"
import script from "./MediaSelect.vue?vue&type=script&lang=js"
export * from "./MediaSelect.vue?vue&type=script&lang=js"
import style0 from "./MediaSelect.vue?vue&type=style&index=0&id=45f79cb2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45f79cb2",
  null
  
)

export default component.exports